import {PRICES_CITIES_SLUGS} from "@pg-rp/navigation";

import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";

export interface IPriceCitiesSummary {
    date: string;
    city: string;
    slug: string;
    availableOffers: number;
    avgPrice: number;
    avgPriceM2: number;
    oldAvailableOffers: number;
    oldAvgPrice: number;
    oldAvgPriceM2: number;
}

export const getCitiesSummary = (
    actualCitiesData: IPriceReportAveragePrices[] | null,
    oldCitiesData: IPriceReportAveragePrices[] | null
): IPriceCitiesSummary[] => {
    if (!actualCitiesData || actualCitiesData.length === 0 || !oldCitiesData || oldCitiesData.length === 0) {
        return [];
    }

    return actualCitiesData
        .filter((cityData) => PRICES_CITIES_SLUGS.includes(cityData.slug_city))
        .reduce((acc, cityData) => {
            const oldCityData = oldCitiesData.find((oldData) => oldData.city === cityData.city);

            if (!oldCityData) {
                return acc;
            }

            return [
                ...acc,
                {
                    date: cityData.date,
                    city: cityData.city,
                    slug: cityData.slug_city,
                    availableOffers: cityData.available_offers,
                    avgPrice: cityData.avg_price,
                    avgPriceM2: cityData.avg_price_m2,
                    oldAvailableOffers: oldCityData.available_offers,
                    oldAvgPrice: oldCityData.avg_price,
                    oldAvgPriceM2: oldCityData.avg_price_m2
                }
            ];
        }, [] as IPriceCitiesSummary[]);
};
import {PRICES_CITIES_SLUGS} from "@pg-rp/navigation";

import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";

export interface IPriceCitiesSummary {
    date: string;
    city: string;
    slug: string;
    availableOffers: number;
    avgPrice: number;
    avgPriceM2: number;
    oldAvailableOffers: number;
    oldAvgPrice: number;
    oldAvgPriceM2: number;
}

export const getCitiesSummary = (
    actualCitiesData: IPriceReportAveragePrices[] | null,
    oldCitiesData: IPriceReportAveragePrices[] | null
): IPriceCitiesSummary[] => {
    if (!actualCitiesData || actualCitiesData.length === 0 || !oldCitiesData || oldCitiesData.length === 0) {
        return [];
    }

    return actualCitiesData
        .filter((cityData) => PRICES_CITIES_SLUGS.includes(cityData.slug_city))
        .reduce((acc, cityData) => {
            const oldCityData = oldCitiesData.find((oldData) => oldData.city === cityData.city);

            if (!oldCityData) {
                return acc;
            }

            return [
                ...acc,
                {
                    date: cityData.date,
                    city: cityData.city,
                    slug: cityData.slug_city,
                    availableOffers: cityData.available_offers,
                    avgPrice: cityData.avg_price,
                    avgPriceM2: cityData.avg_price_m2,
                    oldAvailableOffers: oldCityData.available_offers,
                    oldAvgPrice: oldCityData.avg_price,
                    oldAvgPriceM2: oldCityData.avg_price_m2
                }
            ];
        }, [] as IPriceCitiesSummary[]);
};
